import React from 'react';
import DefaultTheme from '../themes/DefaultTheme';
import FramePropertyPoll from '../utils/FramePropertyPoll';
class AppLovinApp extends React.Component {
    componentDidMount() {
        if (this.props.hasWrapper) {
            FramePropertyPoll.start();
        }
    }
    componentWillUnmount() {
        if (this.props.hasWrapper) {
            FramePropertyPoll.stop();
        }
    }
    render() {
        return React.createElement(DefaultTheme, null,
            React.createElement(React.Fragment, null, this.props.children));
    }
}
AppLovinApp.defaultProps = {
    hasWrapper: true
};
export default AppLovinApp;
//# sourceMappingURL=AppLovinApp.js.map